<section class="nova-work" [class.work-page]="page()" aria-label="Nova’s tasks">
  <div class="work-intro">
    <span class="work-spark" aria-hidden="true"
      ><i class="pi pi-sparkles"></i
    ></span>
    <div>
      <h2>
        {{
          activity.active().length
            ? "On it. Here’s where things stand."
            : "Your tasks, all in one place."
        }}
      </h2>
      <p>See what I’m working on and pick up what’s ready.</p>
    </div>
    <button
      class="refresh-work"
      type="button"
      aria-label="Refresh Nova’s work"
      (click)="activity.refresh()"
    >
      <i class="pi pi-refresh" aria-hidden="true"></i>
    </button>
  </div>
  <div class="work-filters" role="group" aria-label="Filter Nova’s tasks">
    @for (option of filters(); track option.key) {
    <button
      type="button"
      [attr.aria-pressed]="filter() === option.key"
      (click)="filter.set(option.key)"
    >
      @if(option.key === 'active' && option.count) {<span
        class="filter-live-dot"
        aria-hidden="true"
      ></span
      >} {{ option.label }} <span class="filter-count">{{ option.count }}</span>
    </button>
    }
  </div>
  @if (activity.unavailable()) {
  <div class="work-connection" role="status">
    I’m reconnecting to your latest progress. Your saved tasks are still here.
    <button type="button" (click)="activity.refresh()">Try again</button>
  </div>
  } @for (group of groups(); track group.key) {
  <div class="work-section-title">
    <span>{{ group.title }}</span
    ><span>{{ group.items.length }}</span>
  </div>
  <div class="work-group-grid">
  @for (item of group.items; track item.id) {
  <button
    type="button"
    class="work-card"
    [class.work-unread]="item.unread"
    [class.task-is-working]="group.key === 'active'"
    [class.is-opening]="openingConversationId() === item.conversationId"
    [attr.aria-busy]="openingConversationId() === item.conversationId"
    [disabled]="openingConversationId() === item.conversationId"
    (click)="activity.openItem(item)"
    [attr.aria-label]="'Open chat for ' + item.name"
  >
    <span
      class="work-status"
      [class.work-running]="group.key === 'active'"
      [class.work-attention]="item.status === 'attention'"
      [class.work-cancelled]="item.status === 'cancelled'"
      aria-hidden="true"
      ><i [class]="icon(item)"></i
    ></span>
    <span class="work-copy">
      <span class="task-meta"
        ><span>{{ item.kind === "task" ? "Nova task" : "Website scan" }}</span
        ><span
          class="task-state"
          [class.state-running]="group.key === 'active'"
          [class.state-attention]="item.status === 'attention'"
          >{{ statusLabel(item) }}</span
        ></span
      >
      <strong
        >{{ item.name }} @if(item.unread) {<span
          class="unread-dot"
          aria-label="Unread result"
        ></span
        >}</strong
      >
      @if(group.key === 'active' && (item.steps?.length || 0) > 1) {
      <span class="task-steps" role="list" aria-label="Task progress">
        @for (step of item.steps; track $index) {
        <span role="listitem" [class.step-current]="$last"
          ><i
            [class]="$last ? 'pi pi-circle-fill' : 'pi pi-check'"
            aria-hidden="true"
          ></i
          >{{ step }}</span
        >
        }
      </span>
      } @else {<span>{{ item.detail }}</span
      >}
      <span class="task-footer"
        ><span class="work-cta"
          >{{ openingConversationId() === item.conversationId ? 'Opening chat…' : actionLabel(item) }}
          <i [class]="openingConversationId() === item.conversationId ? 'pi pi-spin pi-spinner' : 'pi pi-arrow-right'" aria-hidden="true"></i></span
        ><small>{{ item.updatedAt | date : "MMM d, h:mm a" }}</small></span
      >
    </span>
  </button>
  }
  </div>
  } @if (!groups().length) {
  <div class="work-empty" role="status">
    <span class="empty-orbit" aria-hidden="true"
      ><i [class]="activity.loading() ? 'pi pi-sparkles' : 'pi pi-check'"></i
    ></span>
    <h3>
      {{
        activity.loading()
          ? "Getting your tasks together…"
          : filter() === "active"
          ? "Nothing running right now"
          : filter() === "attention"
          ? "Nothing needs your attention"
          : filter() === "finished"
          ? "Your results will appear here"
          : "What shall we work on?"
      }}
    </h3>
    <p>
      {{
        filter() === "all"
          ? "Ask me to review, compare, research, or organize something. I’ll keep the progress and results here."
          : "You can switch views to see the rest of your tasks."
      }}
    </p>
    <button
      type="button"
      class="start-task"
      (click)="filter() === 'all' ? ui.open() : filter.set('all')"
    >
      {{ filter() === "all" ? "Start a task" : "See all tasks" }}
      <i class="pi pi-arrow-right" aria-hidden="true"></i>
    </button>
  </div>
  }
  <p class="work-footnote">
    <i class="pi pi-lock" aria-hidden="true"></i> Only your work in this
    organization.
  </p>
</section>
